import { useQuery } from '@connectrpc/connect-query'

import { getMe } from '@enechain/eposition-proto/bffportal/v1/user_service-UserService_connectquery'

type Result = {
  isAdmin: boolean
  isAgreed: boolean
  isLoading: boolean
}

export function useGetMe(): Result {
  const { data, isLoading } = useQuery(getMe)

  return {
    isAdmin: data?.me?.isAdmin ?? false,
    isAgreed: data?.me?.isLatestTermAgreed ?? false,
    isLoading,
  }
}
